// Purity ratio bar — A620/A280 scale: 0.0 → 4.0+
// Maps purityLevel value onto gradient: E18(0.7) -> E25(1.5) -> E30(3.0) -> Analytical(4.0+)
const PurityBar = ({ value = 0.7, label, max = 4, compact = false }) => {
  const pct = Math.max(4, Math.min(100, (value / max) * 100));
  return (
    <div data-testid="purity-ratio-bar" className={compact ? "" : "py-1"}>
      {!compact && (
        <div className="flex items-center justify-between mb-2">
          <span className="font-mono text-[10px] uppercase tracking-widest text-brand-black/55">{label || "A620/A280 Purity"}</span>
          <span className="font-mono text-[11px] font-semibold text-brand-teal">≥ {value.toFixed(1)}</span>
        </div>
      )}
      <div className="relative h-2 bg-brand-green/5 border border-brand-green/15">
        <div className="absolute inset-y-0 left-0 purity-bar" style={{ width: `${pct}%` }} />
        <div className="absolute inset-y-[-3px] border-l border-brand-black/40" style={{ left: `${pct}%` }} />
      </div>
      {!compact && (
        <div className="flex justify-between font-mono text-[9px] uppercase tracking-widest text-brand-black/40 mt-1.5">
          <span>0.0</span>
          <span>E18 · 0.7</span>
          <span>E25 · 1.5</span>
          <span>E30 · 3.0</span>
          <span>4.0+</span>
        </div>
      )}
    </div>
  );
};

export default PurityBar;
